/**
 * @param value
 * @returns {boolean}
 */
function isNotSet(value) {
  return typeof value === 'undefined' || value === null;
}

/**
 * @param value
 * @returns {boolean}
 */
function isString(value) {
  return typeof value === 'string';
}

/**
 * @param value
 * @returns {boolean}
 */
function isStringOrNull(value) {
  return isString(value) || value === null;
}

/**
 * @param value
 * @returns {boolean}
 */
function isStringOrNotSet(value) {
  return isString(value) || isNotSet(value);
}

/**
 * @param value
 * @returns {boolean}
 */
function isNotEmptyString(value) {
  return isString(value) && value.trim() !== '';
}

/**
 * @param value
 * @returns {boolean}
 */
function isNotEmptyStringOrNull(value) {
  return isNotEmptyString(value) || value === null;
}

/**
 * @param value
 * @returns {boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}

/**
 * @param value
 * @returns {boolean}
 */
function isNumberOrNull(value) {
  return isNumber(value) || value === null;
}

/**
 * @param value
 * @returns {boolean}
 */
function isBoolean(value) {
  return typeof value === 'boolean';
}

/**
 * @param value
 * @returns {boolean}
 */
function isArray(value) {
  return Array.isArray(value);
}

/**
 * @param value
 * @returns {boolean}
 */
function isObject(value) {
  return typeof value === 'object';
}

/**
 * @param value
 * @returns {boolean}
 */
function isValidDate(value) {
  const date = new Date(value);

  if (!(date instanceof Date)) {
    return false;
  }

  if (isNaN(date.getTime())) {
    return false;
  }

  return date.toString() !== 'Invalid date';
}

/**
 * @param value
 * @returns {boolean}
 */
function isValidDateOrNull(value) {
  return isValidDate(value) || value === null;
}

export default {
  isNotSet,
  isString,
  isStringOrNull,
  isStringOrNotSet,
  isNotEmptyString,
  isNotEmptyStringOrNull,
  isNumber,
  isNumberOrNull,
  isBoolean,
  isArray,
  isObject,
  isValidDate,
  isValidDateOrNull,
};
